import React from "react";


export default class FrontPeriodicite extends React.Component {
    
    constructor(props) {
        super(props);
        this.ref = React.createRef()
    }

    render() {
        const {devis,oneColumn,focusError,showValidate,changeParams} = this.props.container
        
        const params = devis.params

        let message = devis.validateMessage('periodicite')
        if ( message ) focusError(this.ref)
        if ( !showValidate ) message = undefined


        return <table ref={this.ref} className="periodicite">
                <tbody>
                    <tr>
                        <td className={(params.periodicite=='M')?'selected left':'left'}
                            onClick={()=>{changeParams({'periodicite':'M'})}}
                        >Mensuel</td>
                        <td className={(params.periodicite=='A')?'selected right':'right'}
                            onClick={()=>{changeParams({'periodicite':'A'})}}
                        >Annuel<br/>
                            <span>Jusqu'à 10% d'économie</span>
                        </td></tr>
                </tbody>
            </table>
    }
}